module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"sinon","commonjs2":"sinon","amd":"sinon","root":"sinon"}
 ** module id = 7
 ** module chunks = 0
 **/